export const UPDATE_PROFILE = 'UPDATE_PROFILE' 
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS'
export const GET_PROFILE ='GET_PROFILE'

export default {
    UPDATE_PROFILE,
    PROFILE_SUCCESS,
    GET_PROFILE
}